import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { profileSelector } from 'selectors'
import Page from 'rui/widgets/Page'
import DriveSidebar from 'components/layout/DriveSidebar'
import Thin from 'components/layout/Thin'

import ResetPasswordForm from 'components/form/ResetPassword'
import { withLocalization } from 'localization'

const ResetPasswordPage = ({ localization }) => {
  const { t } = localization

  return (
    <Page sidebar={<DriveSidebar />}>
      <Helmet>
        <title>{t('dweb_common_password')}</title>
      </Helmet>
      <Thin>
        <ResetPasswordForm gotoAfter="/dashboard" />
      </Thin>
    </Page>
  )
}

export default connect(profileSelector)(withLocalization(ResetPasswordPage))
